var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-warning",
  "data-name": "Icon ionic-ios-warning",
  d: "M16.419,5.742,3.649,30.992A2.375,2.375,0,0,0,5.6,34.5H31.151A2.38,2.38,0,0,0,33.1,30.992L20.327,5.742A2.158,2.158,0,0,0,16.419,5.742Zm3.223,10.477-.26,9.531H17.364l-.26-9.531ZM18.373,30.937A1.439,1.439,0,1,1,19.751,29.5,1.395,1.395,0,0,1,18.373,30.937Z",
  transform: "translate(-3.375 -4.5)",
  fill: "#ff003b"
})));
export default __webpack_public_path__ + "static/media/red-info.ec58ebc3.svg";
export { SvgComponent as ReactComponent };